





































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import InlexzoFullFooter from './InlexzoFullFooter.vue';
import Mm1Footer from './Mm1Footer.vue';
import TracleerFooter from './TracleerFooter.vue';
import TremfyaFooter from './TremfyaFooter.vue';
import SimponiFooter from './SimponiFooter.vue';
import LayoutModule from '~/store/layout';
import MedPrescribingInfo from '~/components/MedPrescribingInfo.vue';
import Mm1 from '~/pages/program-requirements/mm1.vue';
import PathModule from '~/store/path';
@Component<Footer>({
    components: {
        MedPrescribingInfo,
        Mm1Footer,
        TracleerFooter,
        TremfyaFooter,
        InlexzoFullFooter
    },
})
export default class Footer extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve
    public path!: PathModule;

    @Prop()
    public brkPoints!: object;
    @Prop({ default: false })
    public isFixed!: boolean;
    isInlexzo = this.layout.program === 'inlexzo';

    footerKey = 0;
    mounted() {
        this.layout.replaceProgramName(this.layout.configuration.programName, this.layout.previousProgramName);
    }

    get footerForInlexzoProgramRequirements() {
        return this.isInlexzo && this.$route.fullPath.startsWith('/program-requirements/inlexzo')
    }

    @Watch('layout.program', { deep: true })
    public watchLayoutProgramName() {
        this.footerKey += 1;
        this.isInlexzo = this.layout.program === 'inlexzo';
    }

    @Watch('layout.configuration.programName', { deep: true })
    public watchProgramName(programName: string) {
        this.layout.replaceProgramName(programName, this.layout.previousProgramName);
    }

    public get footerInfoLinkLocation() {
        return this.layout.configuration.footerInfoLinkLocation;
    }

    public get isTopOrBottomBar() {
        return ['top', 'bottom'].includes(this.footerInfoLinkLocation);
    }

    public get isLeftOrRightBar() {
        return ['left', 'right'].includes(this.footerInfoLinkLocation);
    }
}
